<div class="bottomsheet-header">
  <unh-icon
    class="horizontal-bar"
    url="https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/bottomsheet-header-icon.svg"
  ></unh-icon>
  <unh-text-icon>
    <unh-icon class="label-icon" [url]="icon"></unh-icon>
    <span>{{ args.label }}</span>
  </unh-text-icon>
</div>
